// Module
var code = "<div role=\"dialog\" aria-label=\"Select user\"> <select-user :select=\"select\" :selected-ids=\"selectedIds\" :excluded-ids=\"excludedIds\" :allow-unassigned=\"allowUnassigned\" :unassigned-placeholder=\"unassignedPlaceholder\"> </select-user> </div> ";
// Exports
export default code;